import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';

const CountryId = {
    SwedishCountryId: 215,
    UkCountryId: 235,
    DanishCountryId: 61,
    NorwegianCountryId: 165,
    FinnishCountryId: 75,
    FrenchCountryId: 76,
    EstonianCountryId: 70,
    SpanishCountryCode: 209,
    GermanCountryCode: 83,
    ItalianCountryCode: 39,
    ChineseCountryCode: 86,
    MongolCountryCode: 976,
    ArabicCountryCode: 971,
    VietnameseCountryCode: 243,
    IcelandicCountryCode: 354,
    TurkishCountryCode: 228,
};

export function getDefaultCountryId(applicationLanguage: FiApplicationLanguageType) {
    switch (applicationLanguage) {
        case FiApplicationLanguageType.Swedish:
            return CountryId.SwedishCountryId;

        case FiApplicationLanguageType.English:
            return CountryId.UkCountryId;

        case FiApplicationLanguageType.Danish:
            return CountryId.DanishCountryId;

        case FiApplicationLanguageType.Norwegian:
            return CountryId.NorwegianCountryId;

        case FiApplicationLanguageType.Finnish:
            return CountryId.FinnishCountryId;

        case FiApplicationLanguageType.French:
            return CountryId.FrenchCountryId;

        case FiApplicationLanguageType.Estonian:
            return CountryId.EstonianCountryId;

        case FiApplicationLanguageType.Spanish:
            return CountryId.SpanishCountryCode;

        case FiApplicationLanguageType.German:
            return CountryId.GermanCountryCode;

        case FiApplicationLanguageType.Italian:
            return CountryId.ItalianCountryCode;

        case FiApplicationLanguageType.Chinese:
            return CountryId.ChineseCountryCode;

        case FiApplicationLanguageType.Arabic:
            return CountryId.ArabicCountryCode;

        case FiApplicationLanguageType.Mongol:
            return CountryId.MongolCountryCode;

        case FiApplicationLanguageType.Vietnamese:
            return CountryId.VietnameseCountryCode;

        case FiApplicationLanguageType.Icelandic:
            return CountryId.IcelandicCountryCode;

        case FiApplicationLanguageType.Turkish:
            return CountryId.TurkishCountryCode;

        default:
            return CountryId.SwedishCountryId;
    }
}
